import { gql, useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import { doesClientRequireSafetyGuardsAtom } from "../../state";
import { useSetAtom } from "jotai";
import { Server } from "../../../apollo/types";

export type ClientRequiresTelehealthSafetyGuardsQuery = {
  clientRequiresTelehealthSafetyGuards: boolean;
};

export type ClientRequiresTelehealthSafetyGuardsQueryVariables = {
  patientShortId: string;
};

export const GET_CLIENT_SAFETY_GUARD = gql`
  query ClientRequiresTelehealthSafetyGuards($patientShortId: String!) {
    clientRequiresTelehealthSafetyGuards(patientShortId: $patientShortId)
  }
`;

// This query is used to determine if the client requires safety guards, which currently applies to clients under 13 years old.
// It is used to determine if the client is eligible to fill out any forms.

export function useGetClientSafetyGuard() {
  const { patientShortId } = useParams();
  const setDoesClientRequireSafetyGuards = useSetAtom(
    doesClientRequireSafetyGuardsAtom,
  );
  return useQuery<ClientRequiresTelehealthSafetyGuardsQuery>(
    GET_CLIENT_SAFETY_GUARD,
    {
      variables: {
        patientShortId,
      },
      context: { server: Server.MONOLITH, skipAuth: true },
      onCompleted(data) {
        setDoesClientRequireSafetyGuards(
          data.clientRequiresTelehealthSafetyGuards,
        );
      },
    },
  );
}
